import { Divider, Typography } from "@mui/material"
import type { ReactElement } from "react"

import { FilterCheckbox } from "@/components/common/Filters"
import type { Option } from "@/types/form-fields"

interface InventoryFilterListProps<T extends string> {
  label: string
  control: any
  name: string
  values: T[]
  options: Option<T>[]
  onChange: (values: T[]) => void
  testId: string
}

export const InventoryFilterList = <T extends string>({
  label,
  control,
  name,
  values,
  options,
  onChange,
  testId,
}: InventoryFilterListProps<T>): ReactElement => (
  <div data-testid={testId}>
    <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
      {label}
    </Typography>
    <Divider className='mb-4' />
    <div className='flex flex-col px-4'>
      {options.map((option) => (
        <FilterCheckbox
          key={option.value}
          control={control}
          name={name}
          value={option.value}
          values={values}
          label={option.label}
          onFilterChange={(values) => onChange(values as T[])}
          data-testid={`${testId}.option-${option.value}`}
        />
      ))}
    </div>
  </div>
)
